import { Image } from "@rai/ui/adapters/navigation";
import { cn } from "@rai/core/lib/utils";

/** Official artwork lives exclusively in public/brand. */
export function BrandLogo({ dark = false, className }: { dark?: boolean; className?: string }) {
  return (
    <Image
      src={`/brand/svg/logo-horizontal-no-tagline${dark ? "-dark" : ""}.svg`}
      alt="Rai Computer"
      width={939.3}
      height={94.9}
      className={cn("h-auto w-52 max-w-full", className)}
      loading="eager"
    />
  );
}
